/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignoutRouteImport } from './routes/signout'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as WaitingForActivationRouteImport } from './routes/waiting-for-activation'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedCompareRouteImport } from './routes/_authenticated/compare'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedHeatmapRouteImport } from './routes/_authenticated/heatmap'
import { Route as AuthenticatedRankingRouteImport } from './routes/_authenticated/ranking'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as IrCnpjRouteRouteImport } from './routes/ir/$cnpj/route'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedCompaniesCnpjRouteRouteImport } from './routes/_authenticated/companies/$cnpj/route'
import { Route as AuthenticatedFundosIndexRouteImport } from './routes/_authenticated/fundos/index'
import { Route as AuthenticatedFundosCnpjRouteRouteImport } from './routes/_authenticated/fundos/$cnpj/route'
import { Route as AuthenticatedFundosDashboardRouteImport } from './routes/_authenticated/fundos/dashboard'
import { Route as AuthenticatedFundosScreenerRouteImport } from './routes/_authenticated/fundos/screener'
import { Route as AuthenticatedIntelFinancialsRouteImport } from './routes/_authenticated/intel/financials'
import { Route as AuthenticatedIntelGovernanceRouteImport } from './routes/_authenticated/intel/governance'
import { Route as AuthenticatedIntelInsiderRouteImport } from './routes/_authenticated/intel/insider'
import { Route as AuthenticatedIntelPayRouteImport } from './routes/_authenticated/intel/pay'
import { Route as AuthenticatedIntelWorkforceRouteImport } from './routes/_authenticated/intel/workforce'
import { Route as AuthenticatedPgmqAdminIndexRouteImport } from './routes/_authenticated/pgmq-admin/index'
import { Route as AuthenticatedSettingsApiKeysRouteImport } from './routes/_authenticated/settings/api-keys'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsFollowingRouteImport } from './routes/_authenticated/settings/following'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedUpdaterIndexRouteImport } from './routes/_authenticated/updater/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedWatchlistIndexRouteImport } from './routes/_authenticated/watchlist/index'
import { Route as IrCnpjIndexRouteImport } from './routes/ir/$cnpj/index'
import { Route as AuthenticatedCompaniesCnpjIndexRouteImport } from './routes/_authenticated/companies/$cnpj/index'
import { Route as AuthenticatedCompaniesCnpjItrEvolutionRouteImport } from './routes/_authenticated/companies/$cnpj/itr-evolution'
import { Route as AuthenticatedCompaniesCnpjPeerBenchmarkRouteImport } from './routes/_authenticated/companies/$cnpj/peer-benchmark'
import { Route as AuthenticatedDocumentsTypeIndexRouteImport } from './routes/_authenticated/documents/$type/index'
import { Route as AuthenticatedFundosCnpjIndexRouteImport } from './routes/_authenticated/fundos/$cnpj/index'
import { Route as AuthenticatedFundosCnpjDocumentosRouteImport } from './routes/_authenticated/fundos/$cnpj/documentos'
import { Route as AuthenticatedIntelNetworkMapRouteImport } from './routes/_authenticated/intel/network/map'
import { Route as AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRouteImport } from './routes/_authenticated/documents/$type/$cnpj/$year/$referenceDate/index'
import { Route as AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRouteImport } from './routes/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/index'
import { Route as AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRouteImport } from './routes/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/index'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignoutRoute = SignoutRouteImport.update({
  id: '/signout',
  path: '/signout',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitingForActivationRoute = WaitingForActivationRouteImport.update({
  id: '/waiting-for-activation',
  path: '/waiting-for-activation',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCompareRoute = AuthenticatedCompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedHeatmapRoute = AuthenticatedHeatmapRouteImport.update({
  id: '/heatmap',
  path: '/heatmap',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRankingRoute = AuthenticatedRankingRouteImport.update({
  id: '/ranking',
  path: '/ranking',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const IrCnpjRouteRoute = IrCnpjRouteRouteImport.update({
  id: '/ir/$cnpj',
  path: '/ir/$cnpj',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesCnpjRouteRoute =
  AuthenticatedCompaniesCnpjRouteRouteImport.update({
    id: '/companies/$cnpj',
    path: '/companies/$cnpj',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFundosIndexRoute =
  AuthenticatedFundosIndexRouteImport.update({
    id: '/fundos/',
    path: '/fundos/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFundosCnpjRouteRoute =
  AuthenticatedFundosCnpjRouteRouteImport.update({
    id: '/fundos/$cnpj',
    path: '/fundos/$cnpj',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFundosDashboardRoute =
  AuthenticatedFundosDashboardRouteImport.update({
    id: '/fundos/dashboard',
    path: '/fundos/dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFundosScreenerRoute =
  AuthenticatedFundosScreenerRouteImport.update({
    id: '/fundos/screener',
    path: '/fundos/screener',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIntelFinancialsRoute =
  AuthenticatedIntelFinancialsRouteImport.update({
    id: '/intel/financials',
    path: '/intel/financials',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIntelGovernanceRoute =
  AuthenticatedIntelGovernanceRouteImport.update({
    id: '/intel/governance',
    path: '/intel/governance',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIntelInsiderRoute =
  AuthenticatedIntelInsiderRouteImport.update({
    id: '/intel/insider',
    path: '/intel/insider',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIntelPayRoute = AuthenticatedIntelPayRouteImport.update({
  id: '/intel/pay',
  path: '/intel/pay',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedIntelWorkforceRoute =
  AuthenticatedIntelWorkforceRouteImport.update({
    id: '/intel/workforce',
    path: '/intel/workforce',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPgmqAdminIndexRoute =
  AuthenticatedPgmqAdminIndexRouteImport.update({
    id: '/pgmq-admin/',
    path: '/pgmq-admin/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsApiKeysRoute =
  AuthenticatedSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsFollowingRoute =
  AuthenticatedSettingsFollowingRouteImport.update({
    id: '/following',
    path: '/following',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedUpdaterIndexRoute =
  AuthenticatedUpdaterIndexRouteImport.update({
    id: '/updater/',
    path: '/updater/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedWatchlistIndexRoute =
  AuthenticatedWatchlistIndexRouteImport.update({
    id: '/watchlist/',
    path: '/watchlist/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const IrCnpjIndexRoute = IrCnpjIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IrCnpjRouteRoute,
} as any)
const AuthenticatedCompaniesCnpjIndexRoute =
  AuthenticatedCompaniesCnpjIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompaniesCnpjRouteRoute,
  } as any)
const AuthenticatedCompaniesCnpjItrEvolutionRoute =
  AuthenticatedCompaniesCnpjItrEvolutionRouteImport.update({
    id: '/itr-evolution',
    path: '/itr-evolution',
    getParentRoute: () => AuthenticatedCompaniesCnpjRouteRoute,
  } as any)
const AuthenticatedCompaniesCnpjPeerBenchmarkRoute =
  AuthenticatedCompaniesCnpjPeerBenchmarkRouteImport.update({
    id: '/peer-benchmark',
    path: '/peer-benchmark',
    getParentRoute: () => AuthenticatedCompaniesCnpjRouteRoute,
  } as any)
const AuthenticatedDocumentsTypeIndexRoute =
  AuthenticatedDocumentsTypeIndexRouteImport.update({
    id: '/documents/$type/',
    path: '/documents/$type/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFundosCnpjIndexRoute =
  AuthenticatedFundosCnpjIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFundosCnpjRouteRoute,
  } as any)
const AuthenticatedFundosCnpjDocumentosRoute =
  AuthenticatedFundosCnpjDocumentosRouteImport.update({
    id: '/documentos',
    path: '/documentos',
    getParentRoute: () => AuthenticatedFundosCnpjRouteRoute,
  } as any)
const AuthenticatedIntelNetworkMapRoute =
  AuthenticatedIntelNetworkMapRouteImport.update({
    id: '/intel/network/map',
    path: '/intel/network/map',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute =
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRouteImport.update({
    id: '/documents/$type/$cnpj/$year/$referenceDate/',
    path: '/documents/$type/$cnpj/$year/$referenceDate/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute =
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRouteImport.update({
    id: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/',
    path: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute =
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRouteImport.update(
    {
      id: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/',
      path: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/signin': typeof SigninRoute
  '/signout': typeof SignoutRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/waiting-for-activation': typeof WaitingForActivationRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/ir/$cnpj': typeof IrCnpjRouteRouteWithChildren
  '/compare': typeof AuthenticatedCompareRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/heatmap': typeof AuthenticatedHeatmapRoute
  '/ranking': typeof AuthenticatedRankingRoute
  '/companies/$cnpj': typeof AuthenticatedCompaniesCnpjRouteRouteWithChildren
  '/fundos/$cnpj': typeof AuthenticatedFundosCnpjRouteRouteWithChildren
  '/fundos/dashboard': typeof AuthenticatedFundosDashboardRoute
  '/fundos/screener': typeof AuthenticatedFundosScreenerRoute
  '/intel/financials': typeof AuthenticatedIntelFinancialsRoute
  '/intel/governance': typeof AuthenticatedIntelGovernanceRoute
  '/intel/insider': typeof AuthenticatedIntelInsiderRoute
  '/intel/pay': typeof AuthenticatedIntelPayRoute
  '/intel/workforce': typeof AuthenticatedIntelWorkforceRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/following': typeof AuthenticatedSettingsFollowingRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/fundos/': typeof AuthenticatedFundosIndexRoute
  '/pgmq-admin/': typeof AuthenticatedPgmqAdminIndexRoute
  '/updater/': typeof AuthenticatedUpdaterIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/watchlist/': typeof AuthenticatedWatchlistIndexRoute
  '/ir/$cnpj/': typeof IrCnpjIndexRoute
  '/companies/$cnpj/itr-evolution': typeof AuthenticatedCompaniesCnpjItrEvolutionRoute
  '/companies/$cnpj/peer-benchmark': typeof AuthenticatedCompaniesCnpjPeerBenchmarkRoute
  '/fundos/$cnpj/documentos': typeof AuthenticatedFundosCnpjDocumentosRoute
  '/intel/network/map': typeof AuthenticatedIntelNetworkMapRoute
  '/companies/$cnpj/': typeof AuthenticatedCompaniesCnpjIndexRoute
  '/documents/$type/': typeof AuthenticatedDocumentsTypeIndexRoute
  '/fundos/$cnpj/': typeof AuthenticatedFundosCnpjIndexRoute
  '/documents/$type/$cnpj/$year/$referenceDate/': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute
  '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute
  '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute
}
export interface FileRoutesByTo {
  '/signin': typeof SigninRoute
  '/signout': typeof SignoutRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/waiting-for-activation': typeof WaitingForActivationRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/compare': typeof AuthenticatedCompareRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/heatmap': typeof AuthenticatedHeatmapRoute
  '/ranking': typeof AuthenticatedRankingRoute
  '/': typeof AuthenticatedIndexRoute
  '/fundos/dashboard': typeof AuthenticatedFundosDashboardRoute
  '/fundos/screener': typeof AuthenticatedFundosScreenerRoute
  '/intel/financials': typeof AuthenticatedIntelFinancialsRoute
  '/intel/governance': typeof AuthenticatedIntelGovernanceRoute
  '/intel/insider': typeof AuthenticatedIntelInsiderRoute
  '/intel/pay': typeof AuthenticatedIntelPayRoute
  '/intel/workforce': typeof AuthenticatedIntelWorkforceRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/following': typeof AuthenticatedSettingsFollowingRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/fundos': typeof AuthenticatedFundosIndexRoute
  '/pgmq-admin': typeof AuthenticatedPgmqAdminIndexRoute
  '/updater': typeof AuthenticatedUpdaterIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/watchlist': typeof AuthenticatedWatchlistIndexRoute
  '/ir/$cnpj': typeof IrCnpjIndexRoute
  '/companies/$cnpj/itr-evolution': typeof AuthenticatedCompaniesCnpjItrEvolutionRoute
  '/companies/$cnpj/peer-benchmark': typeof AuthenticatedCompaniesCnpjPeerBenchmarkRoute
  '/fundos/$cnpj/documentos': typeof AuthenticatedFundosCnpjDocumentosRoute
  '/intel/network/map': typeof AuthenticatedIntelNetworkMapRoute
  '/companies/$cnpj': typeof AuthenticatedCompaniesCnpjIndexRoute
  '/documents/$type': typeof AuthenticatedDocumentsTypeIndexRoute
  '/fundos/$cnpj': typeof AuthenticatedFundosCnpjIndexRoute
  '/documents/$type/$cnpj/$year/$referenceDate': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute
  '/documents/$type/$cnpj/$year/$referenceDate/$idDoc': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute
  '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/signin': typeof SigninRoute
  '/signout': typeof SignoutRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/waiting-for-activation': typeof WaitingForActivationRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/ir/$cnpj': typeof IrCnpjRouteRouteWithChildren
  '/_authenticated/compare': typeof AuthenticatedCompareRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/heatmap': typeof AuthenticatedHeatmapRoute
  '/_authenticated/ranking': typeof AuthenticatedRankingRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/companies/$cnpj': typeof AuthenticatedCompaniesCnpjRouteRouteWithChildren
  '/_authenticated/fundos/$cnpj': typeof AuthenticatedFundosCnpjRouteRouteWithChildren
  '/_authenticated/fundos/dashboard': typeof AuthenticatedFundosDashboardRoute
  '/_authenticated/fundos/screener': typeof AuthenticatedFundosScreenerRoute
  '/_authenticated/intel/financials': typeof AuthenticatedIntelFinancialsRoute
  '/_authenticated/intel/governance': typeof AuthenticatedIntelGovernanceRoute
  '/_authenticated/intel/insider': typeof AuthenticatedIntelInsiderRoute
  '/_authenticated/intel/pay': typeof AuthenticatedIntelPayRoute
  '/_authenticated/intel/workforce': typeof AuthenticatedIntelWorkforceRoute
  '/_authenticated/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/following': typeof AuthenticatedSettingsFollowingRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/fundos/': typeof AuthenticatedFundosIndexRoute
  '/_authenticated/pgmq-admin/': typeof AuthenticatedPgmqAdminIndexRoute
  '/_authenticated/updater/': typeof AuthenticatedUpdaterIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/watchlist/': typeof AuthenticatedWatchlistIndexRoute
  '/ir/$cnpj/': typeof IrCnpjIndexRoute
  '/_authenticated/companies/$cnpj/itr-evolution': typeof AuthenticatedCompaniesCnpjItrEvolutionRoute
  '/_authenticated/companies/$cnpj/peer-benchmark': typeof AuthenticatedCompaniesCnpjPeerBenchmarkRoute
  '/_authenticated/fundos/$cnpj/documentos': typeof AuthenticatedFundosCnpjDocumentosRoute
  '/_authenticated/intel/network/map': typeof AuthenticatedIntelNetworkMapRoute
  '/_authenticated/companies/$cnpj/': typeof AuthenticatedCompaniesCnpjIndexRoute
  '/_authenticated/documents/$type/': typeof AuthenticatedDocumentsTypeIndexRoute
  '/_authenticated/fundos/$cnpj/': typeof AuthenticatedFundosCnpjIndexRoute
  '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute
  '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute
  '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/': typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/signout'
    | '/signup'
    | '/sso-callback'
    | '/waiting-for-activation'
    | '/settings'
    | '/ir/$cnpj'
    | '/compare'
    | '/dashboard'
    | '/heatmap'
    | '/ranking'
    | '/companies/$cnpj'
    | '/fundos/$cnpj'
    | '/fundos/dashboard'
    | '/fundos/screener'
    | '/intel/financials'
    | '/intel/governance'
    | '/intel/insider'
    | '/intel/pay'
    | '/intel/workforce'
    | '/settings/api-keys'
    | '/settings/appearance'
    | '/settings/following'
    | '/settings/notifications'
    | '/settings/profile'
    | '/companies/'
    | '/fundos/'
    | '/pgmq-admin/'
    | '/updater/'
    | '/users/'
    | '/watchlist/'
    | '/ir/$cnpj/'
    | '/companies/$cnpj/itr-evolution'
    | '/companies/$cnpj/peer-benchmark'
    | '/fundos/$cnpj/documentos'
    | '/intel/network/map'
    | '/companies/$cnpj/'
    | '/documents/$type/'
    | '/fundos/$cnpj/'
    | '/documents/$type/$cnpj/$year/$referenceDate/'
    | '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/'
    | '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signin'
    | '/signout'
    | '/signup'
    | '/sso-callback'
    | '/waiting-for-activation'
    | '/settings'
    | '/compare'
    | '/dashboard'
    | '/heatmap'
    | '/ranking'
    | '/'
    | '/fundos/dashboard'
    | '/fundos/screener'
    | '/intel/financials'
    | '/intel/governance'
    | '/intel/insider'
    | '/intel/pay'
    | '/intel/workforce'
    | '/settings/api-keys'
    | '/settings/appearance'
    | '/settings/following'
    | '/settings/notifications'
    | '/settings/profile'
    | '/companies'
    | '/fundos'
    | '/pgmq-admin'
    | '/updater'
    | '/users'
    | '/watchlist'
    | '/ir/$cnpj'
    | '/companies/$cnpj/itr-evolution'
    | '/companies/$cnpj/peer-benchmark'
    | '/fundos/$cnpj/documentos'
    | '/intel/network/map'
    | '/companies/$cnpj'
    | '/documents/$type'
    | '/fundos/$cnpj'
    | '/documents/$type/$cnpj/$year/$referenceDate'
    | '/documents/$type/$cnpj/$year/$referenceDate/$idDoc'
    | '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao'
  id:
    | '__root__'
    | '/_authenticated'
    | '/signin'
    | '/signout'
    | '/signup'
    | '/sso-callback'
    | '/waiting-for-activation'
    | '/_authenticated/settings'
    | '/ir/$cnpj'
    | '/_authenticated/compare'
    | '/_authenticated/dashboard'
    | '/_authenticated/heatmap'
    | '/_authenticated/ranking'
    | '/_authenticated/'
    | '/_authenticated/companies/$cnpj'
    | '/_authenticated/fundos/$cnpj'
    | '/_authenticated/fundos/dashboard'
    | '/_authenticated/fundos/screener'
    | '/_authenticated/intel/financials'
    | '/_authenticated/intel/governance'
    | '/_authenticated/intel/insider'
    | '/_authenticated/intel/pay'
    | '/_authenticated/intel/workforce'
    | '/_authenticated/settings/api-keys'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/following'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/profile'
    | '/_authenticated/companies/'
    | '/_authenticated/fundos/'
    | '/_authenticated/pgmq-admin/'
    | '/_authenticated/updater/'
    | '/_authenticated/users/'
    | '/_authenticated/watchlist/'
    | '/ir/$cnpj/'
    | '/_authenticated/companies/$cnpj/itr-evolution'
    | '/_authenticated/companies/$cnpj/peer-benchmark'
    | '/_authenticated/fundos/$cnpj/documentos'
    | '/_authenticated/intel/network/map'
    | '/_authenticated/companies/$cnpj/'
    | '/_authenticated/documents/$type/'
    | '/_authenticated/fundos/$cnpj/'
    | '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/'
    | '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/'
    | '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  SigninRoute: typeof SigninRoute
  SignoutRoute: typeof SignoutRoute
  SignupRoute: typeof SignupRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  WaitingForActivationRoute: typeof WaitingForActivationRoute
  IrCnpjRouteRoute: typeof IrCnpjRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signout': {
      id: '/signout'
      path: '/signout'
      fullPath: '/signout'
      preLoaderRoute: typeof SignoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waiting-for-activation': {
      id: '/waiting-for-activation'
      path: '/waiting-for-activation'
      fullPath: '/waiting-for-activation'
      preLoaderRoute: typeof WaitingForActivationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/compare': {
      id: '/_authenticated/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof AuthenticatedCompareRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/heatmap': {
      id: '/_authenticated/heatmap'
      path: '/heatmap'
      fullPath: '/heatmap'
      preLoaderRoute: typeof AuthenticatedHeatmapRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ranking': {
      id: '/_authenticated/ranking'
      path: '/ranking'
      fullPath: '/ranking'
      preLoaderRoute: typeof AuthenticatedRankingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/ir/$cnpj': {
      id: '/ir/$cnpj'
      path: '/ir/$cnpj'
      fullPath: '/ir/$cnpj'
      preLoaderRoute: typeof IrCnpjRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/$cnpj': {
      id: '/_authenticated/companies/$cnpj'
      path: '/companies/$cnpj'
      fullPath: '/companies/$cnpj'
      preLoaderRoute: typeof AuthenticatedCompaniesCnpjRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fundos/': {
      id: '/_authenticated/fundos/'
      path: '/fundos'
      fullPath: '/fundos/'
      preLoaderRoute: typeof AuthenticatedFundosIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fundos/$cnpj': {
      id: '/_authenticated/fundos/$cnpj'
      path: '/fundos/$cnpj'
      fullPath: '/fundos/$cnpj'
      preLoaderRoute: typeof AuthenticatedFundosCnpjRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fundos/dashboard': {
      id: '/_authenticated/fundos/dashboard'
      path: '/fundos/dashboard'
      fullPath: '/fundos/dashboard'
      preLoaderRoute: typeof AuthenticatedFundosDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fundos/screener': {
      id: '/_authenticated/fundos/screener'
      path: '/fundos/screener'
      fullPath: '/fundos/screener'
      preLoaderRoute: typeof AuthenticatedFundosScreenerRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/intel/financials': {
      id: '/_authenticated/intel/financials'
      path: '/intel/financials'
      fullPath: '/intel/financials'
      preLoaderRoute: typeof AuthenticatedIntelFinancialsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/intel/governance': {
      id: '/_authenticated/intel/governance'
      path: '/intel/governance'
      fullPath: '/intel/governance'
      preLoaderRoute: typeof AuthenticatedIntelGovernanceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/intel/insider': {
      id: '/_authenticated/intel/insider'
      path: '/intel/insider'
      fullPath: '/intel/insider'
      preLoaderRoute: typeof AuthenticatedIntelInsiderRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/intel/pay': {
      id: '/_authenticated/intel/pay'
      path: '/intel/pay'
      fullPath: '/intel/pay'
      preLoaderRoute: typeof AuthenticatedIntelPayRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/intel/workforce': {
      id: '/_authenticated/intel/workforce'
      path: '/intel/workforce'
      fullPath: '/intel/workforce'
      preLoaderRoute: typeof AuthenticatedIntelWorkforceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pgmq-admin/': {
      id: '/_authenticated/pgmq-admin/'
      path: '/pgmq-admin'
      fullPath: '/pgmq-admin/'
      preLoaderRoute: typeof AuthenticatedPgmqAdminIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/api-keys': {
      id: '/_authenticated/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthenticatedSettingsApiKeysRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/following': {
      id: '/_authenticated/settings/following'
      path: '/following'
      fullPath: '/settings/following'
      preLoaderRoute: typeof AuthenticatedSettingsFollowingRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/updater/': {
      id: '/_authenticated/updater/'
      path: '/updater'
      fullPath: '/updater/'
      preLoaderRoute: typeof AuthenticatedUpdaterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/watchlist/': {
      id: '/_authenticated/watchlist/'
      path: '/watchlist'
      fullPath: '/watchlist/'
      preLoaderRoute: typeof AuthenticatedWatchlistIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/ir/$cnpj/': {
      id: '/ir/$cnpj/'
      path: '/'
      fullPath: '/ir/$cnpj/'
      preLoaderRoute: typeof IrCnpjIndexRouteImport
      parentRoute: typeof IrCnpjRouteRoute
    }
    '/_authenticated/companies/$cnpj/': {
      id: '/_authenticated/companies/$cnpj/'
      path: '/'
      fullPath: '/companies/$cnpj/'
      preLoaderRoute: typeof AuthenticatedCompaniesCnpjIndexRouteImport
      parentRoute: typeof AuthenticatedCompaniesCnpjRouteRoute
    }
    '/_authenticated/companies/$cnpj/itr-evolution': {
      id: '/_authenticated/companies/$cnpj/itr-evolution'
      path: '/itr-evolution'
      fullPath: '/companies/$cnpj/itr-evolution'
      preLoaderRoute: typeof AuthenticatedCompaniesCnpjItrEvolutionRouteImport
      parentRoute: typeof AuthenticatedCompaniesCnpjRouteRoute
    }
    '/_authenticated/companies/$cnpj/peer-benchmark': {
      id: '/_authenticated/companies/$cnpj/peer-benchmark'
      path: '/peer-benchmark'
      fullPath: '/companies/$cnpj/peer-benchmark'
      preLoaderRoute: typeof AuthenticatedCompaniesCnpjPeerBenchmarkRouteImport
      parentRoute: typeof AuthenticatedCompaniesCnpjRouteRoute
    }
    '/_authenticated/documents/$type/': {
      id: '/_authenticated/documents/$type/'
      path: '/documents/$type'
      fullPath: '/documents/$type/'
      preLoaderRoute: typeof AuthenticatedDocumentsTypeIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fundos/$cnpj/': {
      id: '/_authenticated/fundos/$cnpj/'
      path: '/'
      fullPath: '/fundos/$cnpj/'
      preLoaderRoute: typeof AuthenticatedFundosCnpjIndexRouteImport
      parentRoute: typeof AuthenticatedFundosCnpjRouteRoute
    }
    '/_authenticated/fundos/$cnpj/documentos': {
      id: '/_authenticated/fundos/$cnpj/documentos'
      path: '/documentos'
      fullPath: '/fundos/$cnpj/documentos'
      preLoaderRoute: typeof AuthenticatedFundosCnpjDocumentosRouteImport
      parentRoute: typeof AuthenticatedFundosCnpjRouteRoute
    }
    '/_authenticated/intel/network/map': {
      id: '/_authenticated/intel/network/map'
      path: '/intel/network/map'
      fullPath: '/intel/network/map'
      preLoaderRoute: typeof AuthenticatedIntelNetworkMapRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/': {
      id: '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/'
      path: '/documents/$type/$cnpj/$year/$referenceDate'
      fullPath: '/documents/$type/$cnpj/$year/$referenceDate/'
      preLoaderRoute: typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/': {
      id: '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/'
      path: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc'
      fullPath: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/'
      preLoaderRoute: typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/': {
      id: '/_authenticated/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/'
      path: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao'
      fullPath: '/documents/$type/$cnpj/$year/$referenceDate/$idDoc/$versao/'
      preLoaderRoute: typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsApiKeysRoute: typeof AuthenticatedSettingsApiKeysRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsFollowingRoute: typeof AuthenticatedSettingsFollowingRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsApiKeysRoute: AuthenticatedSettingsApiKeysRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsFollowingRoute: AuthenticatedSettingsFollowingRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedCompaniesCnpjRouteRouteChildren {
  AuthenticatedCompaniesCnpjItrEvolutionRoute: typeof AuthenticatedCompaniesCnpjItrEvolutionRoute
  AuthenticatedCompaniesCnpjPeerBenchmarkRoute: typeof AuthenticatedCompaniesCnpjPeerBenchmarkRoute
  AuthenticatedCompaniesCnpjIndexRoute: typeof AuthenticatedCompaniesCnpjIndexRoute
}

const AuthenticatedCompaniesCnpjRouteRouteChildren: AuthenticatedCompaniesCnpjRouteRouteChildren =
  {
    AuthenticatedCompaniesCnpjItrEvolutionRoute:
      AuthenticatedCompaniesCnpjItrEvolutionRoute,
    AuthenticatedCompaniesCnpjPeerBenchmarkRoute:
      AuthenticatedCompaniesCnpjPeerBenchmarkRoute,
    AuthenticatedCompaniesCnpjIndexRoute: AuthenticatedCompaniesCnpjIndexRoute,
  }

const AuthenticatedCompaniesCnpjRouteRouteWithChildren =
  AuthenticatedCompaniesCnpjRouteRoute._addFileChildren(
    AuthenticatedCompaniesCnpjRouteRouteChildren,
  )

interface AuthenticatedFundosCnpjRouteRouteChildren {
  AuthenticatedFundosCnpjDocumentosRoute: typeof AuthenticatedFundosCnpjDocumentosRoute
  AuthenticatedFundosCnpjIndexRoute: typeof AuthenticatedFundosCnpjIndexRoute
}

const AuthenticatedFundosCnpjRouteRouteChildren: AuthenticatedFundosCnpjRouteRouteChildren =
  {
    AuthenticatedFundosCnpjDocumentosRoute:
      AuthenticatedFundosCnpjDocumentosRoute,
    AuthenticatedFundosCnpjIndexRoute: AuthenticatedFundosCnpjIndexRoute,
  }

const AuthenticatedFundosCnpjRouteRouteWithChildren =
  AuthenticatedFundosCnpjRouteRoute._addFileChildren(
    AuthenticatedFundosCnpjRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedCompareRoute: typeof AuthenticatedCompareRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedHeatmapRoute: typeof AuthenticatedHeatmapRoute
  AuthenticatedRankingRoute: typeof AuthenticatedRankingRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCompaniesCnpjRouteRoute: typeof AuthenticatedCompaniesCnpjRouteRouteWithChildren
  AuthenticatedFundosCnpjRouteRoute: typeof AuthenticatedFundosCnpjRouteRouteWithChildren
  AuthenticatedFundosDashboardRoute: typeof AuthenticatedFundosDashboardRoute
  AuthenticatedFundosScreenerRoute: typeof AuthenticatedFundosScreenerRoute
  AuthenticatedIntelFinancialsRoute: typeof AuthenticatedIntelFinancialsRoute
  AuthenticatedIntelGovernanceRoute: typeof AuthenticatedIntelGovernanceRoute
  AuthenticatedIntelInsiderRoute: typeof AuthenticatedIntelInsiderRoute
  AuthenticatedIntelPayRoute: typeof AuthenticatedIntelPayRoute
  AuthenticatedIntelWorkforceRoute: typeof AuthenticatedIntelWorkforceRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedFundosIndexRoute: typeof AuthenticatedFundosIndexRoute
  AuthenticatedPgmqAdminIndexRoute: typeof AuthenticatedPgmqAdminIndexRoute
  AuthenticatedUpdaterIndexRoute: typeof AuthenticatedUpdaterIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedWatchlistIndexRoute: typeof AuthenticatedWatchlistIndexRoute
  AuthenticatedIntelNetworkMapRoute: typeof AuthenticatedIntelNetworkMapRoute
  AuthenticatedDocumentsTypeIndexRoute: typeof AuthenticatedDocumentsTypeIndexRoute
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute: typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute: typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute: typeof AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedCompareRoute: AuthenticatedCompareRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedHeatmapRoute: AuthenticatedHeatmapRoute,
  AuthenticatedRankingRoute: AuthenticatedRankingRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCompaniesCnpjRouteRoute:
    AuthenticatedCompaniesCnpjRouteRouteWithChildren,
  AuthenticatedFundosCnpjRouteRoute:
    AuthenticatedFundosCnpjRouteRouteWithChildren,
  AuthenticatedFundosDashboardRoute: AuthenticatedFundosDashboardRoute,
  AuthenticatedFundosScreenerRoute: AuthenticatedFundosScreenerRoute,
  AuthenticatedIntelFinancialsRoute: AuthenticatedIntelFinancialsRoute,
  AuthenticatedIntelGovernanceRoute: AuthenticatedIntelGovernanceRoute,
  AuthenticatedIntelInsiderRoute: AuthenticatedIntelInsiderRoute,
  AuthenticatedIntelPayRoute: AuthenticatedIntelPayRoute,
  AuthenticatedIntelWorkforceRoute: AuthenticatedIntelWorkforceRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedFundosIndexRoute: AuthenticatedFundosIndexRoute,
  AuthenticatedPgmqAdminIndexRoute: AuthenticatedPgmqAdminIndexRoute,
  AuthenticatedUpdaterIndexRoute: AuthenticatedUpdaterIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedWatchlistIndexRoute: AuthenticatedWatchlistIndexRoute,
  AuthenticatedIntelNetworkMapRoute: AuthenticatedIntelNetworkMapRoute,
  AuthenticatedDocumentsTypeIndexRoute: AuthenticatedDocumentsTypeIndexRoute,
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute:
    AuthenticatedDocumentsTypeCnpjYearReferenceDateIndexRoute,
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute:
    AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocIndexRoute,
  AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute:
    AuthenticatedDocumentsTypeCnpjYearReferenceDateIdDocVersaoIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface IrCnpjRouteRouteChildren {
  IrCnpjIndexRoute: typeof IrCnpjIndexRoute
}

const IrCnpjRouteRouteChildren: IrCnpjRouteRouteChildren = {
  IrCnpjIndexRoute: IrCnpjIndexRoute,
}

const IrCnpjRouteRouteWithChildren = IrCnpjRouteRoute._addFileChildren(
  IrCnpjRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  SigninRoute: SigninRoute,
  SignoutRoute: SignoutRoute,
  SignupRoute: SignupRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  WaitingForActivationRoute: WaitingForActivationRoute,
  IrCnpjRouteRoute: IrCnpjRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
